export default __webpack_public_path__ + "static/media/TableSawImg.5c865e8e.png";